import React from 'react';
import './Verifying.scss';  
import row from "../../../Assets/image (58).png";
import logo from "../../../Assets/image (53).png";
import sidelogo from "../../../Assets/image (59).png";

export default function Verifying() {
  return (
  
        <div className="verifying-form-container">

          <div className="verifying-header">
            <span className="verifying-title">Verify Your Email Address</span>
            <p className="verifying-subtext">Nam ultricies lectus a risus blandit elementum. Quisque arcu arcu, tristique a eu in diam.</p>
          </div>

          <div className="verifying-code-section">
            <span className="verifying-label">Verification Code</span>
            <span className="verifying-resend">Resend Code</span>
          </div>

          <div className="verifying-input-wrapper">
            <input type="text" />
          </div>

          <button className="verifying-btn">Verify Code</button>

        </div>
   
  );
}
